module.exports = __webpack_public_path__ + "img/avatar_none.e6549a81.png";